import { WebGlCanvas, NotificationLoad } from "./webgl_board";
import { PresentationState } from "./utilities";
import { MeasuringTool } from "./MeasuringTool";
import { viewerFOVArea } from "./ViewerFOVArea";
import { CanvasImage } from "./images";
import { BFF_BASE_PATH } from "@/core/utils"

var viewer;
var kbd_shortcuts_heatmap = ["F1", "F2", "F3", "F4", "F5", "F6", "F7"];
export class Viewer {
  constructor() {
    document.getElementById("image_canvas").style.zIndex = 1;
    document.getElementById("d2_canvas").style.zIndex = 10;

    this.canvas_gl = new WebGlCanvas("image_canvas");

    this.is_dragging = false;
    this.use_transparency = true;
    this.savedPresentationState = null;
    this.isCrosshairEnabled = true;

    this.canvas = document.getElementById("image_canvas");
    this.canvas_2d = document.getElementById("d2_canvas");
    this.canvas_2d_context = this.canvas_2d.getContext("2d");

    this.canvas.width = window.innerWidth;
    this.canvas.height = window.innerHeight;

    this.canvas_2d.width = window.innerWidth;
    this.canvas_2d.height = window.innerHeight;

    this.thumbnail_image = new utils.ThumbnailImage();
    this.thumbnail_results = new utils.ThumbnailImage();

    this.layers = [];

    this.size = [0, 0];
    this.start_pos = [0, 0];
    this.end_pos = [0, 0];
    this.offset = [0, 0];
    this.pixel_spacing = [0, 0];
    this.zoom = 1;
    this.start_click = null;
    this.start_touch_click = null;
    this.arrow_timeout = null;
    this.total_width = 0;
    this.total_height = 0;
    this.curr_zoom = 1.0;
    this.transparency = 0.35;
    this.heatmap = "jet";
    this.arrow_rate = 40;
    this.map_width = 0;

    this.start_level = -1;
    this.jet_colormap = [];

    viewer = this;

    window.addEventListener("resize", resizeCanvas, false);
    this.canvas_2d.addEventListener("mousedown", handleMouseDown);

    if (process.env.CONFIG_ENABLE_MEASURMENT === true) {
      this.measuringTool = new MeasuringTool(this);
    }
    if (process.env.CONFIG_ENABLE_VIEWER_FOV === true) {
      this.viewerFovArea = new viewerFOVArea(this);
    }
  }

  registerEvents() {
    // mouseup/mousemove events on windows to continue/stop panning when over menu buttons
    window.addEventListener("mouseup", handleMouseUp);
    window.addEventListener("mousemove", handleMouseMove);
    this.canvas_2d.addEventListener("wheel", handleMouseWheel);
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);
  }

  unregisterEvents() {
    window.removeEventListener("mouseup", handleMouseUp);
    window.removeEventListener("mousemove", handleMouseMove);
    this.canvas_2d.removeEventListener("wheel", handleMouseWheel);
    window.removeEventListener("keydown", handleKeyDown);
    window.removeEventListener("keyup", handleKeyUp);
  }

  Reset() {
    reset();
  }

  SetZoom(value) {
    setZoom(value);
  }

  SetZoomAndLocation(zoom, x, y) {
    setZoomAndLocation(zoom, x, y);
  }

  draw_image(element, x, y, sw, dw) {
    this.canvas_2d_context.drawImage(element, 0, 0, sw, sw, x - dw / 2, y - dw / 2, dw, dw);
  }

  build_zoom_array() {
    var max_zoom = ((this.total_width / this.size[0]) * 80) / this.magnification;
    var zoom = max_zoom;
    var magnification = 80;
    var zoom_array = [];
    var dz = 8;
    while (zoom >= 1) {
      zoom_array.push(zoom);
      magnification -= dz;
      zoom = (magnification * max_zoom) / 80;
      if (magnification <= 1) dz = 0.2;
      else if (magnification <= 5) dz = 0.5;
      else if (magnification <= 10) dz = 1;
      else if (magnification <= 20) dz = 2;
      else if (magnification <= 40) dz = 4;
    }
    zoom_array.reverse();
    zoom_array[0] = 1;
    return zoom_array;
  }

  Init(data) {
    this.image_data = data;
    $("body").trigger("ibex:viewer-data-ready", data);
    this.left_arrow = false;
    this.up_arrow = false;
    this.right_arrow = false;
    this.down_arrow = false;
    this.total_width = data["level_dimensions"][0][0];
    this.total_height = data["level_dimensions"][0][1];
    this.magnification = data["magnification"];
    this.real_levels = data["real_levels"];
    this.good_levels = data["good_levels"];
    var properties = data["properties"];

    // find start level that matches screen size in the best way
    var index = 0;
    var window_size = [window.innerWidth, window.innerHeight];
    var screen_ratio = window.innerWidth / window.innerHeight;
    var image_ratio = this.total_width / this.total_height;
    if (screen_ratio > image_ratio) {
      index = 0;
    } else {
      index = 1;
    }

    var optimal_level = -1;
    var min_ratio = 1000000;
    var level = 0;
    while (level < data["level_count"]) {
      var size = data["level_dimensions"][level];
      var ratio = Math.abs(1.0 - size[index] / window_size[index]);
      if (ratio < min_ratio) {
        min_ratio = ratio;
        optimal_level = level;
      }
      level++;
    }
    if (optimal_level == -1) optimal_level = data["level_count"] - 1;

    while (
      optimal_level < data["level_count"] &&
      (data["level_dimensions"][optimal_level][0] > 4000 ||
        data["level_dimensions"][optimal_level][1] > 3000)
    )
      optimal_level++;

    optimal_level = Math.min(optimal_level, data["level_count"] - 1);
    // create layers per level where levels start from 0 - highest resolution and end at the resolution that matches to screen size
    // each layer contains tiled images of size 1000x1000 for high resolution (more than 2000 pixels width or height)
    // layers with small resolution will contain only one image (without tiling)
    this.start_level = optimal_level;
    level = 0;
    while (level <= this.start_level) {
      var width = data["level_dimensions"][level][0];
      var height = data["level_dimensions"][level][1];
      var w, h;
      if ((width < 2000 && height < 2000) || level == this.start_level) {
        w = width;
        h = height;
      } else {
        w = 1024;
        h = 1024;
      }
      this.layers[level] = new utils.Layer(level, width, height, w, h, this.real_levels[level]);
      level++;
    }
    this.curr_level = this.start_level;

    // get pixel spacing for level 0
    this.pixel_spacing = [0, 0];
    if (properties) {
      var pix_spacing_key_x = "openslide.mpp-x";
      var pix_spacing_key_y = "openslide.mpp-y";
      if (
        properties.hasOwnProperty(pix_spacing_key_x) &&
        properties.hasOwnProperty(pix_spacing_key_y)
      ) {
        this.pixel_spacing = [
          parseFloat(properties[pix_spacing_key_x]),
          parseFloat(properties[pix_spacing_key_y]),
        ];
      }
    }

    this.size_initialized = false;
    updateSize();

    // calculate zoom for each layer
    this.start_level = this.curr_level;
    this.layers[this.start_level].zoom = 1;
    for (var i = this.start_level - 1; i >= 0; i--)
      this.layers[i].zoom = this.layers[i + 1].zoom * 2;

    this.zoom_array = this.build_zoom_array();

    // load image of start layer
    if (this.zoom_array.length == 1) this.zoom = 1.0;
    else this.zoom = this.zoom_array[0];
    this.zoom_index = 0;

    this.updateThumbnailResults();
    update_position();
    this.reload_canvas(null, true);

    this.savedPresentationState = null;
    $("#zoom_text").text("");
    $("#zoom_btn").removeClass("is-active");

    this.registerEvents();

    this.originalPresentationState = this.GetPresentationState();
    this.originalPresentationState.zoom2fit = true;
  }

  reload_canvas(callback, load_slide) {
    if (this.image_data == null) return;
    if (load_slide) this.canvas_gl.load_slide(window.current_slide_id, this.image_data, false);
    this.canvas_gl.load_roi(callback ? new NotificationLoad(callback) : null);

    // we can't use eventBridgeApi here since it's impacting performance
    utils.dispatchCustomEvent("heatmaps-pan-zoom", $("#heatmaps").get(0), {
      viewer,
      resetViewerSize: false,
    });
  }

  clear_canvas() {
    this.unregisterEvents();
    this.image_data = null;
    if (this.thumbnail_results != null) this.thumbnail_results.valid = false;
    if (this.thumbnail_image != null) this.thumbnail_image.valid = false;
    if (this.canvas_gl != null) this.canvas_gl.clear_slide();
    if (this.canvas_2d_context != null)
      this.canvas_2d_context.clearRect(0, 0, this.canvas_2d.width, this.canvas_2d.height);
    $("#zoom_text").text("");
    $("#zoom_btn").removeClass("is-active");
    this.savedPresentationState = null;
    this.originalPresentationState = null;
  }

  updateThumbnailResults() {
    this.thumbnail_results.valid = false;

    var image_ratio = this.total_width / this.total_height;
    if (image_ratio < 1) {
      var thumbnail_width = 90;
      var thumbnail_height = thumbnail_width / image_ratio;
    } else {
      var thumbnail_height = 90;
      var thumbnail_width = thumbnail_height * image_ratio;
    }
    this.map_width = thumbnail_width + 20;

    this.thumbnail_image.image.src =
      `${BFF_BASE_PATH}/get_thumbnail/` +
      window.current_slide_id +
      "/" +
      parseInt(thumbnail_width) +
      "/" +
      parseInt(thumbnail_height);
  }

  GetPresentationState() {
    var actual_size = [this.end_pos[0] - this.start_pos[0], this.end_pos[1] - this.start_pos[1]];
    var size = [
      (80 * this.canvas.width) / this.image_data.dimensions[0] / this.curr_zoom / this.zoom,
      (80 * this.canvas.height) / this.image_data.dimensions[1] / this.curr_zoom / this.zoom,
    ];
    var ps = new PresentationState();
    ps.zoom = this.zoom;
    ps.start_pos = this.start_pos;
    ps.center_pos = [
      (this.end_pos[0] + this.start_pos[0]) / 2,
      (this.end_pos[1] + this.start_pos[1]) / 2,
    ];
    ps.size2actual = actual_size[0] / size[0];

    return ps;
  }

  SetPresentationState(ps) {
    // set zoom
    this.zoom_index = utils.indexOfClosest(this.zoom_array, ps.zoom);
    this.curr_zoom = this.zoom_array[this.zoom_index] / ps.zoom;
    this.zoom = this.zoom_array[this.zoom_index];

    // set location
    this.start_pos = ps.start_pos;
    this.offset = [0, 0];

    var ratio = ps.size2actual / this.curr_zoom / this.zoom;

    var size = [
      ((80 * this.canvas.width) / this.image_data.dimensions[0]) * ratio,
      ((80 * this.canvas.height) / this.image_data.dimensions[1]) * ratio,
    ];

    if (ps.zoom2fit) {
      var minSize = Math.min(size[0], size[1]);
      size[0] /= minSize;
      size[1] /= minSize;
      this.start_pos = [(1 - size[0]) / 2, (1 - size[1]) / 2];
    }

    this.end_pos = [this.start_pos[0] + size[0], this.start_pos[1] + size[1]];

    update_position();
    redraw();
  }

  SetZoom2Fit() {
    this.SetPresentationState(this.originalPresentationState);
    utils.dispatchCustomEvent("heatmaps-pan-zoom", $("#heatmaps").get(0), {
      viewer,
      resetViewerSize: true,
    });
  }
}

function setZoom(zoom_value) {
  var zoom = (viewer.zoom_array[viewer.zoom_array.length - 1] * zoom_value) / 80;
  const screen_pos = [viewer.canvas.width / 2, viewer.canvas.height / 2];
  set_zoom(screen_pos, zoom);
}

function setZoomAndLocation(zoom_value, x, y) {
  var zoom = (viewer.zoom_array[viewer.zoom_array.length - 1] * zoom_value) / 80;
  var screen_size = [viewer.canvas.width / 2, viewer.canvas.height / 2];
  var image_pos = [x / viewer.image_data.dimensions[0], y / viewer.image_data.dimensions[1]];

  viewer.zoom_index = utils.indexOfClosest(viewer.zoom_array, zoom);
  viewer.curr_zoom = zoom / viewer.zoom;
  viewer.zoom = zoom;

  viewer.offset[0] =
    screen_size[0] -
    ((image_pos[0] - viewer.start_pos[0]) / (viewer.end_pos[0] - viewer.start_pos[0])) *
      viewer.size[0] *
      viewer.curr_zoom;
  viewer.offset[1] =
    screen_size[1] -
    ((image_pos[1] - viewer.start_pos[1]) / (viewer.end_pos[1] - viewer.start_pos[1])) *
      viewer.size[1] *
      viewer.curr_zoom;

  update_position();
  update_current_level();
  redraw();
  update_images();
}

function reset() {
  if (viewer.zoom_array.length == 1) viewer.zoom = 1.0;
  else viewer.zoom = viewer.zoom_array[0];
  viewer.zoom_index = 0;
  viewer.size_initialized = false;
  updateSize();
  redraw();
}

function resizeCanvas() {
  updateSize();
  update_position();
  redraw();
}

// todo: kill it with fire
function isAnyGUIPanelOpen() {
  return (
    $("#preferences_panel").css("display") != "none" ||
    ($("#cases_panel").length && $("#cases_panel").css("display") != "none") ||
    $("#alerts_panel").css("display") != "none" ||
    $('.ib-drop-downs').length
  );
}

function handleMouseDown(e) {
  if (isAnyGUIPanelOpen()) {
    var elements = document.getElementsByClassName("clear_all_widgets_on_click");
    for (var i = 0; i < elements.length; i++) {
      elements[i].style.display = "none";
    }
    $("#pref_btn").removeClass("pref-btn-is-active");
    $("#alerts_btn").removeClass("alerts-btn-is-active");
  }
  if (viewer.image_data == null) return;

  var screen_pos = [e.clientX, e.clientY];

  viewer.start_click = e;
  viewer.start_button_pos = screen_pos;

  if (inside_thumbnail_window(viewer.start_button_pos)) updateSlider(viewer.start_button_pos);
}

function handleMouseUp(e) {
  if (viewer.is_dragging) {
    viewer.is_dragging = false;
  }

  viewer.start_click = null;

  //viewer.reload_canvas();
  update_position();
}

function handleMouseMove(e) {
  var pos = [e.clientX, e.clientY];

  if (viewer.start_click != null) {
    if (inside_thumbnail_window(pos)) updateSlider(pos);
    else {
      window.clearTimeout(viewer.draw_final_timeout);
      var dx = e.clientX - viewer.start_button_pos[0];
      var dy = e.clientY - viewer.start_button_pos[1];
      if (viewer.start_click.button == 0) {
        viewer.offset[0] += dx;
        viewer.offset[1] += dy;
        update_position();
        redraw();
        update_images();
        viewer.draw_final_timeout = setTimeout(redraw, 500);
      }
      viewer.start_button_pos[0] = e.clientX;
      viewer.start_button_pos[1] = e.clientY;
    }
  }
}

function handleMouseWheel(e) {
  var screen_pos = [e.clientX, e.clientY];
  var delta = e.deltaY > 0 ? -1 : 1;
  if (globals.userPreferences.cb_invert_scroll_wheel) delta = -delta;
  change_zoom(screen_pos, delta);
}

window.toggleCrosshair = function () {
  viewer.isCrosshairEnabled = !viewer.isCrosshairEnabled;
  redraw();
};

function drawCrosshair() {
  // center
  var x = viewer.canvas.width / 2;
  var y = viewer.canvas.height / 2;

  // remove aliasing
  x = Math.floor(x) + 0.5;
  y = Math.floor(y) + 0.5;
  viewer.canvas_2d_context.shadowColor = 0;
  viewer.canvas_2d_context.shadowBlur = 0;
  viewer.canvas_2d_context.strokeWidth = 0.5;

  viewer.canvas_2d_context.moveTo(x, y - 15);
  viewer.canvas_2d_context.lineTo(x, y + 15);

  viewer.canvas_2d_context.moveTo(x - 15, y);
  viewer.canvas_2d_context.lineTo(x + 15, y);

  // Line color
  viewer.canvas_2d_context.strokeStyle = "#00000055";

  viewer.canvas_2d_context.stroke();
}

function handleKeyDown(e) {
  if (isAnyGUIPanelOpen()) return;
  const screen_pos = [viewer.canvas.width / 2, viewer.canvas.height / 2];
  if (e.key == "1") {
    setZoom(1);
    return;
  } else if (e.key == "2") {
    setZoom(2);
    return;
  } else if (e.key == "3") {
    setZoom(4);
    return;
  } else if (e.key == "4") {
    setZoom(10);
    return;
  } else if (e.key == "5") {
    setZoom(20);
    return;
  } else if (e.key == "6") {
    setZoom(40);
    return;
  } else if (e.key == "-") {
    change_zoom(screen_pos, -1);
    return;
  } else if (e.key == "+") {
    change_zoom(screen_pos, 1);
    return;
  } else if (e.key == "=") {
    change_zoom(screen_pos, 1);
    return;
  } else if (e.key == "x") {
    toggleCrosshair();
    return;
  } else if (e.key == "Escape") {
    clear_all_widgets();
    return;
  } else if (e.key == "0") {
    viewer.SetZoom2Fit();
    return;
  } else if (e.key == "a" && viewer.measuringTool && viewer.measuringTool.isOpen) {
    viewer.measuringTool.addSection();
    return;
  } else if (kbd_shortcuts_heatmap.includes(e.key)) {
    utils.eventBridgeApi("toggle-heatmap-by-index", {
      index: kbd_shortcuts_heatmap.indexOf(e.key),
    });

    e.preventDefault();
    e.stopPropagation();
  }
  updateArrowKeyStatus(e.keyCode, true);

  if (isArrowPressed()) {
    if (viewer.arrow_timeout != null) window.clearTimeout(viewer.arrow_timeout);
    applyArrowPan();
  }
}

function handleKeyUp(e) {
  if (isAnyGUIPanelOpen()) return;

  updateArrowKeyStatus(e.keyCode, false);

  if (!isArrowPressed()) {
    viewer.draw_final_timeout = setTimeout(redraw, 500);
    if (viewer.arrow_timeout != null) window.clearTimeout(viewer.arrow_timeout);
  }
}

function updateArrowKeyStatus(key, status) {
  if (key == 37) viewer.right_arrow = status;
  else if (key == 38) viewer.down_arrow = status;
  else if (key == 39) viewer.left_arrow = status;
  else if (key == 40) viewer.up_arrow = status;
}

function isArrowPressed() {
  return viewer.left_arrow || viewer.up_arrow || viewer.right_arrow || viewer.down_arrow;
}

function applyArrowPan() {
  var dx = viewer.size[0] / viewer.arrow_rate;
  var dy = viewer.size[1] / viewer.arrow_rate;

  if (viewer.left_arrow) viewer.offset[0] -= dx;
  if (viewer.right_arrow) viewer.offset[0] += dx;
  if (viewer.up_arrow) viewer.offset[1] -= dy;
  if (viewer.down_arrow) viewer.offset[1] += dy;

  update_position();
  redraw();
  update_images();

  if (isArrowPressed()) viewer.arrow_timeout = setTimeout(applyArrowPan, 1000 / viewer.arrow_rate);
}

function change_zoom(screen_pos, delta) {
  window.clearTimeout(viewer.draw_final_timeout);

  const image_pos = screen_to_image(screen_pos);

  if (viewer.zoom_array.length > 1) {
    viewer.zoom_index += delta;
    viewer.zoom_index = Math.max(viewer.zoom_index, 0);
    viewer.zoom_index = Math.min(viewer.zoom_index, viewer.zoom_array.length - 1);
    viewer.curr_zoom = viewer.zoom_array[viewer.zoom_index] / viewer.zoom;
    viewer.zoom = viewer.zoom_array[viewer.zoom_index];
  } else {
    var dy = 1.1 * delta;
    if (delta < 0) dy = 1 / dy;
    var new_zoom = viewer.zoom * dy;
    new_zoom = Math.max(new_zoom, 1.0);
    new_zoom = Math.min(new_zoom, 10.0);
    viewer.curr_zoom = new_zoom / viewer.zoom;
    viewer.zoom = new_zoom;
  }

  viewer.offset[0] =
    screen_pos[0] -
    ((image_pos[0] - viewer.start_pos[0]) / (viewer.end_pos[0] - viewer.start_pos[0])) *
      viewer.size[0] *
      viewer.curr_zoom;
  viewer.offset[1] =
    screen_pos[1] -
    ((image_pos[1] - viewer.start_pos[1]) / (viewer.end_pos[1] - viewer.start_pos[1])) *
      viewer.size[1] *
      viewer.curr_zoom;

  update_position();
  var curr_level = viewer.curr_level;
  update_current_level();
  if (curr_level != viewer.curr_level) {
    redraw();
    update_images();
  } else {
    redraw();
    update_images();
    viewer.draw_final_timeout = setTimeout(redraw, 500);
  }
}

function set_zoom(screen_pos, zoom) {
  const image_pos = screen_to_image(screen_pos);

  if (viewer.zoom_array.length == 0) {
    zoom = Math.max(zoom, 1.0);
    zoom = Math.min(zoom, 10.0);
  }
  // find matched index
  var index = 0;
  for (var i = 1; i < viewer.zoom_array.length; i++) {
    if (Math.abs(zoom - viewer.zoom_array[i]) < Math.abs(zoom - viewer.zoom_array[index]))
      index = i;
  }
  viewer.zoom_index = index;
  viewer.curr_zoom = zoom / viewer.zoom;
  viewer.zoom = zoom;

  viewer.offset[0] =
    screen_pos[0] -
    ((image_pos[0] - viewer.start_pos[0]) / (viewer.end_pos[0] - viewer.start_pos[0])) *
      viewer.size[0] *
      viewer.curr_zoom;
  viewer.offset[1] =
    screen_pos[1] -
    ((image_pos[1] - viewer.start_pos[1]) / (viewer.end_pos[1] - viewer.start_pos[1])) *
      viewer.size[1] *
      viewer.curr_zoom;
  update_position();
  update_current_level();
  redraw();
  update_images();
}

function updateSlider(screen) {
  const image_pos = [
    (screen[0] - viewer.start_thumbnail_pos[0]) / viewer.thumbnail_image.width,
    (screen[1] - viewer.start_thumbnail_pos[1]) / viewer.thumbnail_image.height,
  ];
  var offset = [
    image_pos[0] - (viewer.start_pos[0] + viewer.end_pos[0]) / 2.0,
    image_pos[1] - (viewer.start_pos[1] + viewer.end_pos[1]) / 2.0,
  ];
  viewer.start_pos[0] += offset[0];
  viewer.start_pos[1] += offset[1];
  viewer.end_pos[0] += offset[0];
  viewer.end_pos[1] += offset[1];

  update_position();
  update_current_level();
  redraw();
  update_images();
}

function updateSize() {
  viewer.canvas_2d.width = window.innerWidth;
  viewer.canvas_2d.height = window.innerHeight;

  viewer.canvas.width = window.innerWidth;
  viewer.canvas.height = window.innerHeight;

  if (!viewer.size_initialized) {
    viewer.size_initialized = true;

    var screen_ratio = viewer.canvas.width / viewer.canvas.height;
    var image_ratio = viewer.total_width / viewer.total_height;
    let width_factor = 1.0;
    let height_factor = 1.0;
    if (screen_ratio > image_ratio) {
      width_factor = image_ratio / screen_ratio;
    } else {
      height_factor = screen_ratio / image_ratio;
    }
    viewer.size = [viewer.canvas.width * width_factor, viewer.canvas.height * height_factor];
    viewer.start_pos = [0, 0];
    viewer.end_pos = [1, 1];
    viewer.offset = [
      (viewer.canvas.width * (1 - width_factor)) / 2,
      (viewer.canvas.height * (1 - height_factor)) / 2,
    ];
  } else {
    var image_pos = screen_to_image([viewer.canvas.width / 2, viewer.canvas.height / 2]);
    viewer.offset[0] =
      viewer.canvas.width / 2 -
      ((image_pos[0] - viewer.start_pos[0]) / (viewer.end_pos[0] - viewer.start_pos[0])) *
        viewer.size[0];
    viewer.offset[1] =
      viewer.canvas.height / 2 -
      ((image_pos[1] - viewer.start_pos[1]) / (viewer.end_pos[1] - viewer.start_pos[1])) *
        viewer.size[1];

    redraw();
    update_images();
  }
}

function update_current_level() {
  if (viewer.start_level < 0) return;

  var new_level = -1;
  for (var level = viewer.start_level; level >= 1; level--) {
    if (viewer.zoom < viewer.layers[level].zoom) {
      new_level = level;
      break;
    }
  }
  if (new_level < 0) {
    if (viewer != undefined && viewer.zoom >= viewer.layers[0].zoom) new_level = 0;
    else return;
  }
  viewer.curr_level = new_level;
}

function update_images() {
  if (viewer.start_level < 0) return;

  update_current_level();
}

function get_new_position() {
  const p1 = screen_to_image([0, 0]);
  const p2 = screen_to_image([viewer.canvas.width, viewer.canvas.height]);

  const s1 = image_to_screen(p1);
  const s2 = image_to_screen(p2);

  return { start_pos: p1, end_pos: p2, offset: s1, size: [s2[0] - s1[0], s2[1] - s1[1]] };
}

function update_position() {
  var pos = get_new_position();
  viewer.start_pos = pos.start_pos.slice();
  viewer.end_pos = pos.end_pos.slice();
  viewer.offset = pos.offset.slice();
  viewer.size = pos.size.slice();
  viewer.curr_zoom = 1.0;
  viewer.canvas_gl.set_roi(
    viewer.start_pos[0],
    viewer.start_pos[1],
    viewer.end_pos[0],
    viewer.end_pos[1]
  );
  viewer.reload_canvas();
}

export function screen_to_image(screen) {
  const image_pos = [];
  image_pos[0] =
    viewer.start_pos[0] +
    ((screen[0] - viewer.offset[0]) / (viewer.size[0] * viewer.curr_zoom)) *
      (viewer.end_pos[0] - viewer.start_pos[0]);
  image_pos[1] =
    viewer.start_pos[1] +
    ((screen[1] - viewer.offset[1]) / (viewer.size[1] * viewer.curr_zoom)) *
      (viewer.end_pos[1] - viewer.start_pos[1]);
  return image_pos;
}

export function image_to_screen(image) {
  const screen_pos = [];
  screen_pos[0] =
    viewer.offset[0] +
    ((image[0] - viewer.start_pos[0]) / (viewer.end_pos[0] - viewer.start_pos[0])) *
      viewer.size[0] *
      viewer.curr_zoom;
  screen_pos[1] =
    viewer.offset[1] +
    ((image[1] - viewer.start_pos[1]) / (viewer.end_pos[1] - viewer.start_pos[1])) *
      viewer.size[1] *
      viewer.curr_zoom;
  return screen_pos;
}

function inside_thumbnail_window(screen) {
  if (viewer.start_thumbnail_pos == null) return;
  return (
    screen[0] >= viewer.start_thumbnail_pos[0] &&
    screen[1] >= viewer.start_thumbnail_pos[1] &&
    screen[0] <= viewer.end_thumbnail_pos[0] &&
    screen[1] <= viewer.end_thumbnail_pos[1]
  );
}

export function redraw() {
  viewer.canvas_2d_context.clearRect(0, 0, viewer.canvas_2d.width, viewer.canvas_2d.height);
  viewer.canvas_2d_context.beginPath(); // to properly clear grid
  viewer.canvas_2d_context.stroke();

  if (viewer.image_data != null) {
    draw_scale_and_magnification();
    if (viewer.measuringTool) {
      viewer.measuringTool.render();
    }

    if (viewer.thumbnail_image.valid) {
      draw_thumbnail_image();
    }

    if (viewer.isCrosshairEnabled) {
      drawCrosshair();
    }

    if (viewer.viewerFovArea) {
      viewer.viewerFovArea.render()
    }
  }

  viewer.canvas_gl.invalidate();
}

function draw_scale_and_magnification() {
  //WEBGL
  viewer.canvas_2d_context.globalAlpha = 1.0;
  viewer.canvas_2d_context.globalCompositeOperation = "source-over";

  if (viewer.size[0] == 0) {
    $("#zoom_text").text("");
    return;
  }

  var image_to_screen_ratio =
    ((viewer.end_pos[0] - viewer.start_pos[0]) * viewer.total_width) / viewer.size[0];
  var pixel_length_mm = (image_to_screen_ratio * viewer.pixel_spacing[0]) / 1000;

  viewer.pixel_length_mm = pixel_length_mm;

  viewer.canvas_2d_context.translate(0.5, 0.5);

  var magnification = viewer.magnification / image_to_screen_ratio;
  var magnification_str = magnification.toFixed(1) + "x";
  viewer.canvas_2d_context.textBaseline = "center";
  viewer.canvas_2d_context.fillStyle = "#ffffff";
  viewer.canvas_2d_context.fillStyle = "#000000";
  $("#zoom_text").text(isNaN(magnification) ? "" : magnification_str);
  viewer.canvas_2d_context.stroke();
  viewer.canvas_2d_context.translate(-0.5, -0.5);
}

function draw_thumbnail_image() {
  viewer.canvas_2d_context.globalAlpha = 1.0;
  var thumbnail_width = viewer.thumbnail_image.width;
  var thumbnail_height = viewer.thumbnail_image.height;
  var marginBottom = 50;
  var marginLeft = 85;
  if (thumbnail_width < viewer.canvas.width / 2 && thumbnail_height < viewer.canvas.height) {
    viewer.start_thumbnail_pos = [
      marginLeft,
      viewer.canvas.height - thumbnail_height - marginBottom,
    ];
    viewer.end_thumbnail_pos = [thumbnail_width + marginLeft, viewer.canvas.height - marginBottom];
    viewer.canvas_2d_context.drawImage(
      viewer.thumbnail_image.image,
      0,
      0,
      thumbnail_width,
      thumbnail_height,
      viewer.start_thumbnail_pos[0],
      viewer.start_thumbnail_pos[1],
      thumbnail_width,
      thumbnail_height
    );

    if (viewer.thumbnail_results.valid) {
      if (viewer.use_transparency) viewer.canvas_2d_context.globalAlpha = viewer.transparency;
      viewer.canvas_2d_context.drawImage(
        viewer.thumbnail_results.image,
        0,
        0,
        viewer.thumbnail_results.width,
        viewer.thumbnail_results.height,
        viewer.start_thumbnail_pos[0],
        viewer.start_thumbnail_pos[1],
        thumbnail_width,
        thumbnail_height
      );
      viewer.canvas_2d_context.globalAlpha = 1.0;
    }
    viewer.canvas_2d_context.lineWidth = 0.5;
    viewer.canvas_2d_context.strokeStyle = "#000000";
    var pos = get_new_position();

    /*
        Do not allow rectangle out of the thumbnail image
        */
    pos.start_pos[0] = Math.max(pos.start_pos[0], 0);
    pos.start_pos[1] = Math.max(pos.start_pos[1], 0);
    pos.start_pos[0] = Math.min(pos.start_pos[0], 1);
    pos.start_pos[1] = Math.min(pos.start_pos[1], 1);
    pos.end_pos[0] = Math.min(pos.end_pos[0], 1);
    pos.end_pos[1] = Math.min(pos.end_pos[1], 1);
    pos.end_pos[0] = Math.max(pos.end_pos[0], 0);
    pos.end_pos[1] = Math.max(pos.end_pos[1], 0);

    var start_x = pos.start_pos[0] * thumbnail_width;
    var start_y = pos.start_pos[1] * thumbnail_height;
    var img_width = (pos.end_pos[0] - pos.start_pos[0]) * thumbnail_width;
    var img_height = (pos.end_pos[1] - pos.start_pos[1]) * thumbnail_height;
    viewer.canvas_2d_context.shadowBlur = 5;
    viewer.canvas_2d_context.shadowColor = "grey";
    viewer.canvas_2d_context.strokeRect(
      viewer.start_thumbnail_pos[0] + start_x,
      viewer.start_thumbnail_pos[1] + start_y,
      img_width,
      img_height
    );

    viewer.canvas_2d_context.lineWidth = 2;
    viewer.canvas_2d_context.strokeStyle = "#ffffff";
    viewer.canvas_2d_context.strokeRect(
      viewer.start_thumbnail_pos[0],
      viewer.start_thumbnail_pos[1],
      thumbnail_width,
      thumbnail_height
    );
  }
}
